<template>
    <div class="">
        <div class="page-top mb-1 mb-3 clearfix">
            <h1 class="float-left"> Add Team </h1>
            <button class="btn btn-primary float-right submit_form" @click="teamCreated">Next</button>
            <router-link to="/teams" class="btn btn-primary float-right mr-1"> Cancel </router-link>
        </div>
        <div class="peopple-managment-main">
            <ul class="page-status">
                <li class="page-status-list done">
                    <span class="status-highlighter">1</span>
                    Team Details
                </li>
                <li class="page-status-list done">
                    <span class="status-highlighter">2</span>
                    Add Team Members
                </li>
                <li class="page-status-list active">
                    <span class="status-highlighter">3</span>
                    Confirmation Message
                </li>
            </ul>
            <div class="people-management-inner-content p-5">
                <div class="row">
                    <div class="col-md-12">
                        <div class="top-text mb-5 align-center">
                            <h2 class="mb-3"> Team "{{team_name}}" has been added successfully </h2>
                            <!-- <p class="mb-2"> An email has been sent to all selected team members to onboard </p> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                id : this.$route.params.id,
                team_name: ''
            }
        },
        methods: {
            getAddTeamConfirmationData(){
                this.$Progress.start();
                axios.get('/api/addTeamConfirmationData/'+this.id)
                .then(res => {
                    if(res.status == 200){
                        this.team_name = res.data.team.name;
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                        swal.fire({
                            type: 'error',
                            title: 'Error to load form data'
                        });
                    }
                })
                .catch(err => {
                    this.$Progress.fail();
                    swal.fire({
                        type: 'error',
                        title: 'Error to load form data'
                    });
                });
            },
            teamCreated(){
                this.$Progress.start();
                axios.post('/api/addTeamConfirmation/'+this.id)
                .then(res => {
                    if(res.status == 200){
                        this.team_name = res.data.team.name;
                        this.$Progress.finish();
                        toast.fire({
                            type: 'success',
                            title: 'Team created successfully'
                        });
                        this.$router.push('/teams');
                    }else{
                        this.$Progress.fail();
                        swal.fire({
                            type: 'error',
                            title: 'Error to load form data'
                        });
                    }
                })
                .catch(err => {
                    this.$Progress.fail();
                    swal.fire({
                        type: 'error',
                        title: 'Error to load form data'
                    });
                });
            }
        },
        mounted() {
            this.getAddTeamConfirmationData();
        }
    }
</script>
